import { Dispatch } from 'redux';

import { TagPayload } from '@/features/PCP/containers/FilterTagsContainer';
import { setPageNumber } from '@/store/redux/actions/pages/pcp';
import { EmissionFilterStateProps } from '@/store/redux/reducers/pages/pcp/filters/emission';
import { IReduxActionProps } from '@/store/redux/Utils';

export const SET_FILTER_EMISSION = 'SET_FILTER_EMISSION';
export const DELETE_FILTER_EMISSION = 'DELETE_FILTER_EMISSION';
export const RESET_FILTER_EMISSION = 'RESET_FILTER_EMISSION';

export const setFilterEmission = (value: EmissionFilterStateProps) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: SET_FILTER_EMISSION,
      payload: value,
    });
  };
};

export const deleteFilterEmission = (payload: TagPayload) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: DELETE_FILTER_EMISSION,
      payload,
    });
  };
};

export const resetFilterEmission = (): IReduxActionProps => {
  return {
    type: RESET_FILTER_EMISSION,
  };
};
